import ATTR_DATA from "./ATTR_DATA";

//设置label
function setLabel(name) {
  let List = ["username", "password", "iconPhone", "iconPhoneCode"],
    value = "";
  List.includes(name) ? (value = "") : (value = ATTR_DATA[name]);
  return {
    label: value
  };
}
//设置表单项类型
function setFileType(type) {
  return {
    type: type ? type : "text"
  };
}
//设置placeholder
function setPlaceholder(name, placeholder) {
  let list = ["typeProblem", "server", "characterName"],
    value = "",
    startText = "";
  if (placeholder) {
    value = placeholder;
  } else {
    list.includes(name) ? (startText = "请选择") : (startText = "请输入");
    value = `${startText}${ATTR_DATA[name]}`;
  }
  return {
    placeholder: value
  };
}
//设置最大值
function setMaxLength(maxlength) {
  return {
    maxlength
  };
}
//设置右边图标
function setRightIcon(rightIcon) {
  return {
    rightIcon
  };
}
//设置左边图标
function setLeftIcon(leftIcon) {
  return {
    leftIcon
  };
}
function showLimt(limit) {
  return {
    limit
  };
}
//表单项基本配置
function baseField(
  name,
  placeholder = "",
  maxlength = "",
  leftIcon = "",
  rightIcon = "",
  type = "text",
  limit = false
) {
  return {
    ...setLabel(name),
    ...setFileType(type),
    ...setMaxLength(maxlength),
    ...setLeftIcon(leftIcon),
    ...setRightIcon(rightIcon),
    ...setPlaceholder(name, placeholder),
    ...showLimt(limit)
  };
}
//设置基本的表单类型
const setBaseField = {
  password: (
    name,
    placeholder,
    leftIcon = "",
    rightIcon = "",
    type = "text"
  ) => {
    return {
      ...baseField(name, placeholder, 32, leftIcon, rightIcon, type),
      rules: {
        required: true,
        min: 6,
        password: true
      }
    };
  },
  phone: (name, leftIcon = "", rightIcon = "") => {
    return {
      ...baseField(name, null, 11, leftIcon, rightIcon, "tel"),
      rules: {
        required: true,
        regex: /^1\d{10}$/
      }
    };
  },
  code: (name, leftIcon = "", rightIcon = "", maxlength = "6") => {
    return {
      ...baseField(name, null, maxlength, leftIcon, rightIcon, "number", false),
      rules: {
        required: true,
        regex: /^\d{6}$/
      }
    };
  }
};
//有图案账号
const username = {
  ...baseField("username", "请输入账号", 50, "manager"),
  rules: {
    required: true
  }
};
//账号
const userAccount = {
  ...baseField("userAccount", "请输入账号", 50),
  rules: {
    required: true
  }
};
/**
 * 密码类别
 */

//注册密码
const password = {
  ...setBaseField.password(
    "password",
    "请输入密码",
    "lock",
    "closed-eye",
    "password"
  ),
  noTrim: true,
  noChinese: true
};
//账号密码
const accountPassword = {
  ...setBaseField.password(
    "password",
    "请输入密码",
    "lock",
    "closed-eye",
    "password"
  ),
  rules: {
    required: true
  }
};

//申诉密码
const appealPassword = {
  ...setBaseField.password("password"),
  noTrim: true,
  noChinese: true
};
//当前密码
const currentPassword = {
  ...setBaseField.password("currentPassword"),
  noChinese: true,
  noTrim: true,
  rules: {
    required: true
  }
};
//新密码
const newPassword = {
  ...setBaseField.password("newPassword"),
  noTrim: true,
  noChinese: true
};
/**
 * 手机号类别
 */
// 手机号码
const iconPhone = {
  ...setBaseField.phone("iconPhone", "phone")
};
//绑定手机
const bindPhone = {
  ...setBaseField.phone("bindPhone")
};

// 联系手机
const telphone = {
  ...setBaseField.phone("telphone")
};

// 已绑手机
const boundiconPhone = {
  ...setBaseField.phone("boundiconPhone"),
  rules: {
    required: true
  }
};
/**
 * 验证码类别
 */
//有图案手机验证码
const iconPhoneCode = {
  ...setBaseField.code("iconPhoneCode", "youzan-shield")
};

//无图案的手机验证码
const telCode = {
  ...baseField("telCode", null, 6, null, null, "number", false),
  rules: {
    required: true,
    regex: /^\d{6}$/
  }
};

// 姓名
const idName = {
  ...baseField("idName", null, 30),
  rules: {
    required: true,
    regex: /^[\u4E00-\u9FA5]+(\W[\u4E00-\u9FA5]+)*$/,
    min: 2
  }
};
// 姓名
const name = {
  ...baseField("name", null, 6),
  rules: {
    required: true
  }
};
// 身份证号码
const idNumber = {
  ...baseField("idNumber", null, 18),
  rules: {
    required: true,
    card: true
  }
};
//问题类型
const typeProblem = {
  ...baseField("typeProblem", null, null, null, "arrow-down"),
  rules: {
    required: true
  }
};
//服务器
const server = {
  ...baseField("server", null, null, null, "arrow-down"),
  rules: {
    required: true
  }
};
//角色名称
const characterName = {
  ...baseField("characterName", null, null, null, "arrow-down"),
  rules: {
    required: true
  }
};
//问题描述
const problemDes = {
  ...baseField("problemDes", null, 300, null, null, "textarea", true),
  rules: {
    required: true,
    min: 20,
    max: 300
  }
};

//申诉工单号
const appealNumber = {
  ...baseField("appealNumber", null, 20, null, "question"),
  rules: {
    required: true
  }
};

//绑定邮箱
const bindEmail = {
  ...baseField("bindEmail", null, 50, null),
  rules: {
    required: true,
    email: true
  }
};

// 邮箱地址
const emailAddress = {
  ...baseField("emailAddress", null, 50, null),
  rules: {
    required: true,
    email: true
  }
};

// 收件地址
const addresss = {
  ...baseField("addresss", null, 100, null, null, "textarea", true),
  rules: {
    required: true,
    max: 100
  }
};
export default {
  name,
  idName,
  idNumber,
  username,
  userAccount,
  server,
  bindEmail,
  problemDes,
  typeProblem,
  characterName,
  appealNumber,
  iconPhone,
  telphone,
  bindPhone,
  boundiconPhone,
  telCode,
  iconPhoneCode,
  password,
  newPassword,
  appealPassword,
  accountPassword,
  currentPassword,
  emailAddress,
  addresss
};
